namespace Matrix.Rebalancer {
    export namespace SummaryViewFormatService {
        export const baseUrl = 'Rebalancer/SummaryViewFormat';

        export declare function Create(request: Serenity.SaveRequest<SummaryViewFormatRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SummaryViewFormatRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SummaryViewFormatRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<SummaryViewFormatRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Rebalancer/SummaryViewFormat/Create",
            Update = "Rebalancer/SummaryViewFormat/Update",
            Delete = "Rebalancer/SummaryViewFormat/Delete",
            Retrieve = "Rebalancer/SummaryViewFormat/Retrieve",
            List = "Rebalancer/SummaryViewFormat/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>SummaryViewFormatService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
